import styled from 'styled-components'
import { Button as YogaButton } from '@gympass/yoga'
import SMBContainer from '@components/Container'
import getBreakpoint from '@client/utils/breakpoints'

export default styled(SMBContainer)`
  @media (min-width: ${getBreakpoint('md')}px) and (max-width: ${getBreakpoint(
      'lg'
    )}px) {
    max-width: 479px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Button = styled(YogaButton)`
  background-color: ${({ white }) =>
    white ? 'var(--white)' : 'var(--buenos-aires-60)'};
  color: ${({ white }) => (white ? 'var(--buenos-aires-60)' : 'var(--white)')};
  border-color: var(--buenos-aires-60);

  &:not([disabled]):hover {
    box-shadow: 0 4px 8px var(--buenos-aires-60);
  }

  &:active {
    background-color: var(--buenos-aires-50);
    border-color: var(--buenos-aires-50);
  }
`
